// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--xKQN8","description":"a10a3f92e9--description--F1xfT","info":"a10a3f92e9--info--bEqxQ","icon":"a10a3f92e9--icon--ZfcW9"};